module.exports = __webpack_public_path__ + "static/media/triple-photos.fe4f0e69.svg";